export const API_PATHS = {
  EMAILS: 'emails',
  NOTIFICATION_EMAILS: 'notifyEmails',
};
